import { useEffect, useState } from 'react';
import { CiSquarePlus } from "react-icons/ci";
import { CiSquareMinus } from "react-icons/ci";
import Form from 'react-bootstrap/Form'
import FormRange from 'react-bootstrap/FormRange'
import Slider from '@mui/material/Slider';
import MuiInput from '@mui/material/Input';
import { styled } from '@mui/material/styles';

const Input = styled(MuiInput)`
  width: 42px;

  &::after,
  &::before {
    display: none;
  }

  & .MuiInput-input {
    text-align: center;
    padding: 0;
    height: 30px;
    line-height: 30px; /* Match parent div height */
    font-size: 14px;
  }
`;

const CustomSlider = styled(Slider)(({ theme }) => ({
    '& .MuiSlider-thumb': {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        },
    },

}));

export default function ScalarBox(props) {
    const value = props.value
    const setValue = props.setValue
    const step = props.step
    const lowerBound = props.lowerBound
    const upperBound = props.upperBound
    const labelValue = props.labelValue


    useEffect(() => {
        let v = parseInt(value)
        let has_change = false

        if (lowerBound != null && v < lowerBound) {
            v = lowerBound
            has_change = true
        }

        if (upperBound != null && v > upperBound) {
            v = upperBound
            has_change = true
        }

        if (has_change) {
            setValue(v)
        }
    }, [value, lowerBound, upperBound, setValue])

    const handleBlur = () => {
        if (value < 0) {
            setValue(0);
        } else if (value > 100) {
            setValue(100);
        }
    };

    return (
        <>

            <div className='d-flex justify-content-center align-items-center'
                style={{ width: '40px', height: '30px', marginRight: '10px', border: 'solid 1px #DADADA', borderRadius: '2px' }}>
                <Input
                    value={value}
                    size="small"
                    onChange={e => setValue(e.target.value)}
                    onBlur={handleBlur}
                />
            </div>
            <CustomSlider
                value={value}
                size="small"
                style={{ width: '170px', height: '1px' }}
                onChange={e => setValue(e.target.value)}
                disableSwap
                valueLabelDisplay={labelValue}
            />
        </>
    )
}
